import { createSlice } from "@reduxjs/toolkit";
import uuidv4 from "uuid/v4";
import { StateToObj } from "./reduxHelper";

const initialState = {
    "id" : uuidv4(),
    "data": []
}
const addOfflineData = (chatConversationHistoryData,state) => {
    const{ data:stateData} = StateToObj(state)
    const { messages } = chatConversationHistoryData
    let pendlingList = stateData
    for (const key in messages) {
        let msgObj = messages[key]
        if(msgObj?.msgStatus === 1){
            pendlingList.push(msgObj)
        }
    }
    return pendlingList
}
const offlinePendingSlice = createSlice({
    name:'activeChatData',
    initialState,
    reducers:{
        addOfflinePendingData: (_state,payload)=>{
            const { chatConversationHistoryData } = payload.payload
               return {
                "id" : uuidv4(),
                "data":addOfflineData(chatConversationHistoryData,_state)
               }
        }
    }
});

export default offlinePendingSlice.reducer
export const addOfflinePendingData = offlinePendingSlice.actions.addOfflinePendingData